<template>
  <div class="header">
    <div class="header-block">
      <div class="header-menu">
        <div
          class="header-menu__button icon"
          :class="{ 'crist-menu': $store.getters['headerOpened'] }"
          @click="sidebarToggle"
        />
      </div>
      <div class="process-logo process-logo_green">Процессный офис</div>
    </div>
    <div class="right-side">
      <RouterLink :to="{ name: 'Videos' }" class="mr-4">
        <NIcon class="flex justify-content-center align-items-center size-5" size="24">
          <VideoIcon />
        </NIcon>
      </RouterLink>
      <notifyManager class="mr-4" />
      <router-link :to="'/profile'" class="header-block pointer">
        <div class="avatar-icon">
          <div class="white-avatar-icon icon" />
        </div>
        <div class="header-menu__name">{{ userName }}</div>
      </router-link>
    </div>
  </div>
  <!--  <modalWindow @closeHandler="closeProfile" :header="$store.getters.currentUser.name" v-if="profileOpened">
    <template v-slot:preheader>
      <div class="avatar">
        <div class="icon white-avatar-plus-icon"></div>
      </div>
    </template>
    <profile :item="$store.getters.currentUser"></profile>
  </modalWindow>-->
</template>

<script>
import { NIcon } from 'naive-ui'
import VideoIcon from '@vicons/tabler/Video'
import greenLogo from '@/components/widgets/simple-components/logo/greenLogo'
import modalWindow from '@/components/widgets/custom-components/modalWindow/modalWindow'
import profile from '@/components/widgets/custom-components/modalWindow/modalComponents/profile'
import notifyManager from '@/components/widgets/custom-components/notifyManager/notifyManager'

export default {
  name: 'MainHeader',
  components: {
    greenLogo,
    modalWindow,
    profile,
    notifyManager,
    NIcon,
    VideoIcon
  },
  data() {
    return {
      profileOpened: false
    }
  },
  computed: {
    userName() {
      return this.$store.getters['auth/user']?.name || 'John Doe'
    }
  },
  methods: {
    closeProfile() {
      this.profileOpened = false
    },
    openProfile() {
      this.$store.dispatch('USER_GET')
      this.profileOpened = true
    },
    sidebarToggle() {
      this.$store.dispatch('COMMON_STATE_HEADER_TOGGLE')
    }
  }
}
</script>
<style scoped>
.pr20 {
  padding-right: 20px;
}
.right-side {
  display: flex;
}
.avatar {
  margin-right: 20px;
  width: 60px;
  height: 60px;
  background: linear-gradient(180deg, #37c489 0%, #00cccc 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.white-avatar-plus-icon {
  width: 30px;
  height: 30px;
}
.white-avatar-icon {
  width: 12px;
  height: 12px;
}
.avatar-icon {
  margin-right: 10px;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background-image: linear-gradient(180deg, #37c489 0%, #00cccc 100%);
  background-position: center;
}
.header-menu {
  width: 20px;
  height: 20px;
  margin-right: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.header-menu__name {
  color: black;
}
.header-block {
  display: flex;
}
.header-menu__avatar {
  background-image: url("data:image/svg+xml,%3Csvg width='21' height='20' viewBox='0 0 21 20' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Crect x='0.997559' width='20' height='20' rx='10' fill='url(%23paint0_linear_550_617)'/%3E%3Cg filter='url(%23filter0_d_550_617)'%3E%3Ccircle cx='11' cy='8' r='3' stroke='white' shape-rendering='crispEdges'/%3E%3C/g%3E%3Cg filter='url(%23filter1_d_550_617)'%3E%3Cpath d='M7 14C7 13.4477 7.44772 13 8 13H14C14.5523 13 15 13.4477 15 14V14.329C15 14.6693 14.8266 14.9863 14.5218 15.1377C13.8527 15.4702 12.5441 16 11 16C9.45592 16 8.14731 15.4702 7.47818 15.1377C7.17345 14.9863 7 14.6693 7 14.329V14Z' stroke='white' shape-rendering='crispEdges'/%3E%3C/g%3E%3Cdefs%3E%3Cfilter id='filter0_d_550_617' x='7.5' y='4.5' width='8' height='8' filterUnits='userSpaceOnUse' color-interpolation-filters='sRGB'%3E%3CfeFlood flood-opacity='0' result='BackgroundImageFix'/%3E%3CfeColorMatrix in='SourceAlpha' type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' result='hardAlpha'/%3E%3CfeOffset dx='1' dy='1'/%3E%3CfeComposite in2='hardAlpha' operator='out'/%3E%3CfeColorMatrix type='matrix' values='0 0 0 0 0.0117647 0 0 0 0 0.533333 0 0 0 0 0.52549 0 0 0 0.5 0'/%3E%3CfeBlend mode='multiply' in2='BackgroundImageFix' result='effect1_dropShadow_550_617'/%3E%3CfeBlend mode='normal' in='SourceGraphic' in2='effect1_dropShadow_550_617' result='shape'/%3E%3C/filter%3E%3Cfilter id='filter1_d_550_617' x='6.5' y='12.5' width='10' height='5' filterUnits='userSpaceOnUse' color-interpolation-filters='sRGB'%3E%3CfeFlood flood-opacity='0' result='BackgroundImageFix'/%3E%3CfeColorMatrix in='SourceAlpha' type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' result='hardAlpha'/%3E%3CfeOffset dx='1' dy='1'/%3E%3CfeComposite in2='hardAlpha' operator='out'/%3E%3CfeColorMatrix type='matrix' values='0 0 0 0 0.0117647 0 0 0 0 0.533333 0 0 0 0 0.52549 0 0 0 0.5 0'/%3E%3CfeBlend mode='multiply' in2='BackgroundImageFix' result='effect1_dropShadow_550_617'/%3E%3CfeBlend mode='normal' in='SourceGraphic' in2='effect1_dropShadow_550_617' result='shape'/%3E%3C/filter%3E%3ClinearGradient id='paint0_linear_550_617' x1='10.9976' y1='0' x2='10.9976' y2='20' gradientUnits='userSpaceOnUse'%3E%3Cstop stop-color='%2337C489'/%3E%3Cstop offset='1' stop-color='%2300CCCC'/%3E%3C/linearGradient%3E%3C/defs%3E%3C/svg%3E%0A");
  width: 20px;
  height: 20px;
  margin-right: 10px;
}
.header-menu__button.crist-menu {
  background-image: url("data:image/svg+xml,%3Csvg width='18' height='17' viewBox='0 0 18 17' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M11.4018 8.57334L16.9706 14.1421L14.1421 16.9706L8.57334 11.4018L3.00454 16.9706L0.176114 14.1421L5.74491 8.57334L0 2.82843L2.82843 0L8.57334 5.74491L14.3182 0L17.1467 2.82843L11.4018 8.57334Z' fill='url(%23paint0_linear_148_1065)'/%3E%3Cdefs%3E%3ClinearGradient id='paint0_linear_148_1065' x1='8.57334' y1='0' x2='8.57334' y2='16.9706' gradientUnits='userSpaceOnUse'%3E%3Cstop stop-color='%2337C489'/%3E%3Cstop offset='1' stop-color='%2300CCCC'/%3E%3C/linearGradient%3E%3C/defs%3E%3C/svg%3E%0A");
}
.header-menu__button {
  transition: all 0.3s;
  background-image: url("data:image/svg+xml,%3Csvg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M20 0H0V4H20V0ZM20 8H0V12H20V8ZM0 16H20V20H0V16Z' fill='url(%23paint0_linear_550_4740)'/%3E%3Cdefs%3E%3ClinearGradient id='paint0_linear_550_4740' x1='10' y1='0' x2='10' y2='20' gradientUnits='userSpaceOnUse'%3E%3Cstop stop-color='%2337C489'/%3E%3Cstop offset='1' stop-color='%2300CCCC'/%3E%3C/linearGradient%3E%3C/defs%3E%3C/svg%3E%0A");
  width: 20px;
  height: 20px;
  cursor: pointer;
}
.header {
  z-index: 10;
  background-color: white;
  position: fixed;
  box-shadow: 0px 1px 0px #cccccc;
  width: 100%;
  padding: 20px;
  line-height: 20px;
  display: flex;
  justify-content: space-between;
}
</style>
